<!-- RAIZ: tela inteira e espaço pro footer fixo -->
<div class="min-h-screen flex flex-col">

  <!-- CONTEÚDO: 2 colunas, com margem em cima e padding pro footer -->
  <div class="grid grid-cols-2 gap-4 mt-4 pb-16">

    <!-- COLUNA ESQUERDA -->
    <div class="flex flex-col items-center mx-2" [ngClass]="{'h-[calc(100vh-1rem-67px)]': menuOpened == 'HELP'}">
        <div class="mx-2 py-2 rounded-md bg-orange-600 w-full flex justify-center">
            <label class="text-white">{{ status }}</label>
        </div>
        
        <!-- AJUDA quando aberto -->
        <div *ngIf="menuOpened == 'HELP'" class="flex flex-col flex-1 min-h-0 w-full">
          <app-help></app-help>
        </div>

        <!-- BUSCA DE PRODUTOS quando ajuda não está aberto -->
        <app-product-search class="w-full" 
          *ngIf="menuOpened != 'HELP'"
          (productSelected)="onProductSelected($event)"
          (codeSearchRequested)="onCodeSearchRequested($event)">
        </app-product-search>
    </div>

    <!-- COLUNA DIREITA: altura da viewport - topo (mt-4=1rem) - footer (h-16=64px) -->
    <div class="flex flex-col h-[calc(100vh-1rem-67px)] mx-2">
      <!-- quando menuOpened != '' e não for HELP, este bloco some -->
      <div class="flex flex-col flex-1 min-h-0" [hidden]="menuOpened != '' && menuOpened != 'HELP'">

        <!-- INPUT -->
        <div class="w-full">
          <input [(ngModel)]="search"
                 (keyup)="onSearchKeyup($event)"
                 (input)="onSearchInput()"
                 pInputText
                 autocomplete="off"
                 class="w-full"
                 type="text"
                 id="search"
                 placeholder="Pesquisar produto">
        </div>

        <!-- ITENS (área elástica com scroll) -->
        <div id="itensTable" class="flex-1 min-h-0 mt-2 overflow-auto bg-gray-200">
          <p-table 
            [value]="preVenda.items" 
            [paginator]="false"
            styleClass="p-datatable-sm"
            [rowHover]="false"
            [stripedRows]="false"
            [showCurrentPageReport]="false"
            responsiveLayout="scroll"
            class="min-w-full text-sm">

            <ng-template pTemplate="header">
              <tr class="bg-gray-100">
                <th class="text-left px-6 py-3">Produto</th>
                <th class="text-left px-6 py-3">Quantidade</th>
                <th class="text-left px-6 py-3">Preço Unitário (R$)</th>
                <th class="text-left px-6 py-3">Total (R$)</th>
              </tr>
            </ng-template>

            <ng-template pTemplate="body" let-item let-i="rowIndex">
              <tr [id]="'pre-venda-item-' + i">
                <td colspan="4" [ngClass]="{
                    'bg-orange-500 text-white': selectedItemIndex === i,
                    'bg-white hover:bg-orange-50': selectedItemIndex !== i && i % 2 === 0,
                    'bg-orange-50 hover:bg-orange-100': selectedItemIndex !== i && i % 2 !== 0
                  }"
                  class="px-6 py-1 transition-colors">
                  <div class="flex flex-col gap-1">
                    <span class="font-mono">{{ item.productId }}</span>
                    <div class="flex justify-between">
                      <span class="font-mono">{{ item.productName }}</span>
                      <span>{{ item.amount | number: '1.2' }}</span>
                      <span>
                        <ng-container *ngIf="item.listPriceSelling != null && item.listPriceSelling > item.productPrice">
                          <span class="line-through text-gray-500 text-xs mr-1">{{ item.listPriceSelling | currency: 'BRL' }}</span>
                        </ng-container>
                        {{ item.productPrice | currency: 'BRL' }}
                      </span>
                      <span>{{ item.total | currency: 'BRL' }}</span>
                    </div>
                    <div *ngIf="item.promotionId != null && item.listPriceSelling != null && item.listPriceSelling > item.productPrice"
                         class="text-xs text-green-700 font-medium">
                      Preço promocional<span *ngIf="item.promotionDescription"> — {{ item.promotionDescription }}</span>
                    </div>
                    <div class="flex gap-2">
                      <button (click)="addQuantity(item)" class="px-2 bg-green-500 hover:bg-green-600 text-white rounded">+</button>
                      <button (click)="subtractQuantity(item)" class="px-2 bg-yellow-500 hover:bg-yellow-600 text-white rounded">-</button>
                      <button (click)="deleteItem(item)" class="px-2 py-1 bg-red-500 hover:bg-red-600 text-white rounded">Remover</button>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="6" class="text-center py-8 text-gray-500">
                  Nenhum produto adicionado
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <!-- BARRA DE INFO (fica no final) -->
        <div class="h-12 shrink-0 bg-orange-600 mt-2 px-2 rounded-t-md flex items-center text-white">
          <p class="mr-6">
            Cliente: {{ preVenda.customerName || 'Não informado' }}
            <span *ngIf="customerDocument"> ({{ customerDocument }})</span>
          </p>
        </div>

        <!-- TOTAIS (fica no final) -->
        <div class="h-24 shrink-0 p-2 bg-orange-500 text-white rounded-b-md">
          <p>Desconto: {{ preVenda.discountTotal | currency:'BRL' }}</p>
          <p>Total: {{ preVenda.netTotal | currency:'BRL' }}</p>
        </div>
      </div>

      <!-- BUSCA DE CLIENTE quando aberto -->
      <div *ngIf="menuOpened == 'CUSTOMER_SEARCH'">
        <div class="flex flex-col h-full">
          <!-- INPUT -->
          <div class="w-full mb-2">
            <input [(ngModel)]="customerSearch"
                   (keyup)="onCustomerSearchKeyup($event)"
                   (input)="onCustomerSearchInput()"
                   pInputText
                   autocomplete="off"
                   class="w-full"
                   type="text"
                   id="customer-search"
                   placeholder="Pesquisar cliente">
          </div>

          <app-customer-search 
            (customerSelected)="onCustomerSelected($event)">
          </app-customer-search>
        </div>
      </div>

      <!-- ENTRADA MANUAL DE CLIENTE quando aberto -->
      <div *ngIf="menuOpened == 'CUSTOMER_INPUT'">
        <app-customer-input 
          (customerDataChange)="onCustomerDataChange($event)"
          (customerConfirmed)="onCustomerConfirmed($event)">
        </app-customer-input>
      </div>

      <!-- ENTRADA DE DESCONTO quando aberto -->
      <div *ngIf="menuOpened == 'DISCOUNT_INPUT'">
        <app-discount-input 
          [grossTotal]="preVenda.grossTotal"
          (discountConfirmed)="onDiscountConfirmed($event)">
        </app-discount-input>
      </div>

      <!-- LISTA DE PRODUTOS quando aberto -->
      <div *ngIf="menuOpened == 'PRODUCT_LIST'" class="flex flex-col flex-1 min-h-0">
        <app-product-list 
          (productSelected)="onProductSelected($event)">
        </app-product-list>
      </div>
    </div>
  </div>

  <!-- FOOTER FIXO (64px) -->
  <div class="fixed bottom-0 left-0 w-full bg-orange-500 h-16">
    <div class="h-full w-full flex justify-between">
      <button 
        (click)="openHelp()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer  hover:bg-orange-700 rounded-md">
        <span>F1</span><span>Ajuda</span>
      </button>
      <button 
        (click)="openCustomerSearch()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer hover:bg-orange-700 rounded-md">
        <span>F2</span><span>Cliente</span>
      </button>
      <button 
        (click)="openDiscountInput()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer hover:bg-orange-700 rounded-md">
        <span>F3</span><span>Desconto</span>
      </button>
      <button 
        (click)="salvarPreVenda()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer hover:bg-orange-700 rounded-md">
        <span>F5</span><span>Salvar</span>
      </button>
      <button 
        (click)="cancelarPreVenda()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer hover:bg-orange-700 rounded-md">
        <span>F6</span><span>Cancelar</span>
      </button>
      <button 
        (click)="openCustomerInput()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer hover:bg-orange-700 rounded-md">
        <span>F7</span><span>Cpf/Cnpj</span>
      </button>
      <button 
        (click)="openProductList()"
        class="flex flex-col items-center m-1 bg-orange-600 px-6 py-1 text-sm text-white cursor-pointer  hover:bg-orange-700 rounded-md">
        <span>F11</span><span>Produtos</span>
      </button>
    </div>
  </div>

</div>

<p-toast></p-toast>
